import { createAction } from 'redux-act';

import * as auth from '../../core/auth';

export const login = createAction(
  'login',
);
export const loginSuccess = createAction(
  'login success',
  (user) => user
);
export const loginFail = createAction(
  'login fail',
  (error) => error
);

export const sessionRestored = createAction(
  'session restored',
  (user) => user
);

export const resetPassword = createAction(
  'reset password',
);
export const resetPasswordSuccess = createAction(
  'reset password success',
);
export const resetPasswordFail = createAction(
  'reset password fail',
  (error) => error
);

export const forgotPassword = createAction(
  'reset password',
);
export const forgotPasswordSuccess = createAction(
  'forgot password success',
);
export const forgotPasswordFail = createAction(
  'forgot password fail',
  (error) => error
);
export const changeResetTokenExpirationStatus = createAction(
  'change reset token expiration status',
  (status) => status
);

export const reducer = {
  [loginSuccess]: (state, payload) =>
    auth.loginSuccess(state, payload),
  [sessionRestored]: (state, payload) =>
    auth.sessionRestored(state, payload),

  [resetPassword]: (state, payload) =>
    auth.resetPassword(state, payload),
  [resetPasswordSuccess]: (state, payload) =>
    auth.resetPasswordSuccess(state, payload),
  [resetPasswordFail]: (state, payload) =>
    auth.resetPasswordFail(state, payload),

  [forgotPassword]: (state, payload) =>
    auth.forgotPassword(state, payload),
  [forgotPasswordSuccess]: (state, payload) =>
    auth.forgotPasswordSuccess(state, payload),
  [forgotPasswordFail]: (state, payload) =>
    auth.forgotPasswordFail(state, payload),
  [changeResetTokenExpirationStatus]: (state, payload) =>
    auth.changeResetTokenExpirationStatus(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/auth.module.js
 **/